<button
  class="ask-ai"
  [disabled]="!selectedQuestion() || isAskAiDisabled()"
  [loading]="isCreatingAiQuestion()"
  (click)="askAi.emit()"
  tuiButton
  type="button"
  appearance="ai-secondary"
  size="m"
>
  <tui-icon icon="ai" /> Спросить AI
</button>

@if (questions()?.length) {
  <div class="ai-questions">
    <div class="ai-label ai-questions__label">Вы спрашивали</div>

    @for (question of questions(); track $index) {
      <tui-loader
        class="ai-questions__item"
        [showLoader]="question.status === 'processing' || question.status === 'new'"
        [inheritColor]="false"
        [overlay]="true"
      >
        <div class="ai-question">
          <div class="ai-question__header">
            <h3 class="ai-question__title">
              @if (question.isExpanded()) {
                <span>{{ question.question }}</span>
              } @else {
                <tui-line-clamp [content]="question.question" [linesLimit]="1" />
              }
            </h3>
            <button
              class="ai-question__button"
              [class.ai-question__button_active]="question.isExpanded()"
              [disabled]="question.isAnimated()"
              (click)="toggleAiQuestion.emit(question)"
              appearance="secondary-destructive"
              iconStart="plus"
              tuiIconButton
              type="button"
            >
              Показать
            </button>
          </div>

          <tui-expand class="ai-question__text" [expanded]="question.isExpanded()">
            @if (question.isAnimated()) {
              <div
                [markdown]="question.answer"
                [typewriter]="true"
                [speed]="10"
                (typingCompleted)="typingCompleted.emit(question)"
                appMdAnimated
              ></div>
            } @else {
              <div [markdown]="question.answer" appMdAnimated></div>
            }
          </tui-expand>
        </div>
      </tui-loader>
    }
  </div>
}
